import { render } from "./addNewPremisesModal.vue?vue&type=template&id=7ac804eb&scoped=true&ts=true"
import script from "./addNewPremisesModal.vue?vue&type=script&lang=ts"
export * from "./addNewPremisesModal.vue?vue&type=script&lang=ts"

import "./addNewPremisesModal.vue?vue&type=style&index=0&id=7ac804eb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac804eb"]])

export default __exports__